// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zWT5","left":"styles_left__lzOGF"};